import { userService } from '../_services'

export const users = {
  namespaced: true,
  state: {
    all: {}
  },
  actions: {
    getAll ({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest')

      userService.getAll(perpage, page, sortby, descending)
        .then(
          customers => commit('getAllSuccess', customers),
          error => commit('getAllFailure', error)
        )
    },
    addNew ({ commit }, { name, password, email, admin }) {
      console.log(admin)
      userService.addNew(name, password, email, admin)
    }
  },
  mutations: {
    getAllRequest (state) {
      state.all = { loading: true }
    },
    getAllSuccess (state, users) {
      state.all = { items: users }
    },
    getAllFailure (state, error) {
      state.all = { error }
    }
  }
}
